import { render, staticRenderFns } from "./headBgc.vue?vue&type=template&id=0f9119f9&scoped=true&"
import script from "./headBgc.vue?vue&type=script&lang=js&"
export * from "./headBgc.vue?vue&type=script&lang=js&"
import style0 from "./headBgc.vue?vue&type=style&index=0&id=0f9119f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9119f9",
  null
  
)

export default component.exports